import { Classes, FormGroup } from "@blueprintjs/core";
import { Field, useField, useFormikContext } from "formik";
import React, { useState, useCallback, useEffect } from "react";

import {
    CheckboxField,
    DateField,
    MaskedStringField,
    SelectField,
    StringField,
    TextAreaField
} from "./SimpleFormFields";
import ListField from "./ListField";
import ReferenceField from "./ReferenceField";
import { useCompanies } from "hooks/useCompanies";
import { ProjectVariable, Company } from "types";
import CompanySelect from "components/CompanySelect";

type Props = {
    userInputs: { [key: string]: any } | undefined;
    editing?: boolean;
};
const companyFieldName = "company";

export default function ProjectVariables({ userInputs, editing }: Props) {
    const [companies, { loading, error }] = useCompanies();
    const [inputs, setInputs] = useState([] as ProjectVariable[]);
    const { setFieldValue } = useFormikContext<Company>();
    const [company] = useField(companyFieldName);
    const onCompanySelect = useCallback(
        (c: Company) => {
            setFieldValue(companyFieldName, c);
        },
        [setFieldValue]
    );

    //todo: review this
    const setUserInputsReferenceState = useCallback((userInputs: { [key: string]: any }): ProjectVariable[] => {
        let variables: Array<ProjectVariable> = [];
        for (const [key, input] of Object.entries(userInputs)) {
            const o = {
                name: key,
                required: input.required,
                label: input.label,
                type: input.type,
                tableRef: input.snTableNameRef,
                choices: input.choices,
                order: input.order
            };
            variables.push(o);
        }
        return variables.sort((a: ProjectVariable, b: ProjectVariable) => {
            return (a.order || 0) - (b.order || 0);
        });
    }, []);

    useEffect(() => {
        const elements = setUserInputsReferenceState(userInputs ? userInputs : {});
        setInputs(elements);
    }, [userInputs, setUserInputsReferenceState]);

    return (
        <div className={Classes.DIALOG_BODY}>
            <>
                <FormGroup disabled={editing} label="Company" labelInfo="*">
                    <CompanySelect
                        companies={companies}
                        loading={loading}
                        error={error}
                        selectedCompany={company.value}
                        onCompanySelect={onCompanySelect}
                        editing={editing}
                    />
                </FormGroup>
                <FormGroup>
                    {inputs.map((i, idx) => {
                        switch (i.type) {
                            case "string":
                                return <Field key={idx} variable={i} as={StringField} />;
                            case "maskedstring":
                                return <Field key={idx} variable={i} as={MaskedStringField} />;
                            case "textarea":
                                return <Field key={idx} variable={i} as={TextAreaField} />;
                            case "checkbox":
                                return <Field key={idx} variable={i} as={CheckboxField} />;
                            case "choice":
                                return <Field key={idx} variable={i} as={SelectField} />;
                            case "listcollector":
                                return <Field key={idx} variable={i} as={ListField} />;
                            case "reference":
                                return <Field key={idx} variable={i} as={ReferenceField} />;
                            case "date":
                                return <Field key={idx} variable={i} as={DateField} />;
                            default:
                                console.error(`unknown field type of: ${i.type}`);
                                return null;
                        }
                    })}
                </FormGroup>
            </>
        </div>
    );
}
